// 任务型活动使用玩法状态与稳定任务编码，不能以普通奖品列表替代本人进度。
export const taskActivityTypes = Object.freeze(['NEWBIE_TASK', 'DEPOSIT_STREAK'])
export const isTaskActivity = activity => taskActivityTypes.includes(activity?.activityType)
